import type { EntitySource } from 'serviceWorker/channelServers/serveEntityRequests';
import type { ProcessType } from 'shared/domain/process/types/model';
import { getAllProcesses, syncProcesses } from './index';

/** Processes are kept in the worker's memory (not IndexedDB), downloaded once per project. */
export const processSource: EntitySource<ProcessType> = {
  getAll: getAllProcesses,
  sync: syncProcesses,
};
